var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    class: _vm._f("twMerge")(['w-5 h-5 text-gray-500', _vm.className]),
    attrs: {
      "viewBox": "0 0 14 15",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 2.25C3.2284 2.25 0 6.252 0 7.5C0 8.8065 2.4822 12.75 7 12.75C11.5178 12.75 14 8.8065 14 7.5C14 6.252 10.7716 2.25 7 2.25ZM7 9.75C6.58466 9.75 6.17865 9.61804 5.8333 9.37081C5.48796 9.12357 5.2188 8.77217 5.05985 8.36104C4.90091 7.9499 4.85932 7.4975 4.94035 7.06105C5.02138 6.62459 5.22139 6.22368 5.51508 5.90901C5.80877 5.59434 6.18295 5.38005 6.59031 5.29323C6.99767 5.20642 7.41991 5.25097 7.80364 5.42127C8.18736 5.59157 8.51534 5.87996 8.74609 6.24997C8.97684 6.61998 9.1 7.05499 9.1 7.5C9.1 8.09674 8.87875 8.66903 8.48492 9.09099C8.0911 9.51295 7.55695 9.75 7 9.75Z",
      "fill": _vm.color
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }